export default "__VITE_PUBLIC_ASSET__1de4c5dd__"